// Нумерация витринная — ровно та, что приходит в logoType из конфига витрины.
export enum LogoType {
  PartnerOnly = 0,
  PartnerAndTravelata = 1,
  Composite = 2,
}

// Разводящая витрины показывает тот же блок на треть крупнее, чем серп.
export enum HeaderLogoSize {
  M = 'm',
  L = 'l',
}

export enum TravelataMark {
  Color = 'color',
  White = 'white',
}
